import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';

const pulseKeyframes = {
  '@keyframes previewDataPulse': {
    '0%, 100%': { opacity: 1, transform: 'scale(1)' },
    '50%': { opacity: 0.4, transform: 'scale(1.25)' },
  },
};

type PreviewDataStatusBadgeProps = {
  kind: 'live' | 'sample';
  note?: string;
};

export function PreviewDataStatusBadge({
  kind,
  note,
}: PreviewDataStatusBadgeProps) {
  const isLive = kind === 'live';
  const pillBg = useColorModeValue(
    isLive ? 'green.50' : 'yellow.50',
    isLive ? 'rgba(34, 84, 61, 0.55)' : 'rgba(120, 90, 10, 0.45)',
  );
  const pillBorder = useColorModeValue(
    isLive ? 'green.400' : 'yellow.400',
    isLive ? 'green.400' : 'yellow.500',
  );
  const textColor = useColorModeValue(
    isLive ? 'green.800' : 'yellow.900',
    isLive ? 'green.200' : 'yellow.200',
  );
  const noteColor = useColorModeValue('gray.600', 'gray.400');
  const dotColor = isLive ? 'green.400' : 'yellow.400';
  const label = isLive ? 'Live data' : 'Sample data';

  return (
    <Flex
      direction="column"
      align={{ base: 'flex-start', md: 'flex-end' }}
      gap={2}
      flexShrink={0}
    >
      <Flex
        align="center"
        gap={2.5}
        px={4}
        py={2}
        borderRadius="full"
        borderWidth="1.5px"
        borderColor={pillBorder}
        bg={pillBg}
        boxShadow={
          isLive
            ? '0 0 16px rgba(72, 187, 120, 0.4)'
            : '0 0 12px rgba(236, 201, 75, 0.3)'
        }
      >
        <Box
          w="11px"
          h="11px"
          borderRadius="full"
          bg={dotColor}
          flexShrink={0}
          sx={{
            ...pulseKeyframes,
            animation: `previewDataPulse ${isLive ? 1.6 : 2.2}s ease-in-out infinite`,
          }}
        />
        <Text
          fontSize="sm"
          fontWeight="extrabold"
          color={textColor}
          letterSpacing="0.04em"
          textTransform="uppercase"
        >
          {label}
        </Text>
      </Flex>
      {note ? (
        <Text
          fontSize="xs"
          fontWeight="medium"
          color={noteColor}
          maxW="240px"
          lineHeight="1.5"
          textAlign={{ base: 'left', md: 'right' }}
        >
          {note}
        </Text>
      ) : null}
    </Flex>
  );
}
